module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/grupoqa_logo.d37807de.svg";